import * as React from 'react';
import type { SVGProps } from 'react';
const IconMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconMore"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
    />
  </svg>
);
export default IconMore;
